app.messages = {
	Common: {
		BtnOk: 'Gerai',
		BtnCancel: 'Atšaukti',
		Error: 'Klaida',
		FailedToCompleteOperation: 'Nepavyko įvykdyti operacijos. Bandykite vėliau.'
	},

	Dialog: {
		Remove_Title: 'Pašalinti įrašą',
		Remove_Content: 'Ar tikrai norite pašalinti pasirinktą įrašą?',
		RemoveMultiple_Title: 'Pašalinti įrašus',
		RemoveMultiple_Content: 'Ar tikrai norite pašalinti įrašus?'
	},

	Tenders: {
		PublishTender: 'Paskelbti pirkimą',
		SuspendTender: 'Sustabdyti pirkimą',
		MsgParticipantsWillHaveToResubmitBids: 'Dalyviai turės iš naujo pateikti pasiūlymus.',
		ReminderToSubmitProposals: 'Priminimas pateikti pasiūlymus',
		ReminderToSubmitProposalsText: 'Ar norite išsiųsti pasirinktiems tiekėjams priminimą pateikti pasiūlymus? Pastaba: pasirinktiems tiekėjams, kurie jau pateikė pasiūlymą, priminimas nebus siunčiamas.',
		Suppliers_InvitationToParticipateInTender_Header: 'Kvietimas dalyvauti pirkime',
		Suppliers_InvitationToParticipateInTender_Text: 'Ar norite pakartotinai išsiųsti kvietimą dalyvauti pirkime pasirinktiems tiekėjams? Pastaba: pasirinktiems tiekėjams, kurie nėra patvirtinti arba jau dalyvauja pirkime, kvietimas nebus siunčiamas.',
		Suppliers_MsgEmailMissing: 'Pasirinkite arba nurodykite tiekėjo kontaktinį el. pašto adresą.'
	},

	Tender_Compare_MsgFailedToSaveNote: 'Nepavyko įrašyti pastabos.',
	Tender_Compare_MsgFailedToMakeWinnerSupplier: 'Nepavyko padaryti tiekėjo nugalėtoju.',

	Tender_Details_MsgFailedToSaveNote: 'Nepavyko įrašyti pastabos.',
	Tender_Details_MsgTenderArchived: 'Pirkimas suarchyvuotas.',
	Tender_Details_MsgTenderUnArchived: 'Pirkimas išarchivuotas.',
	Tender_Details_MsgTenderClosed: 'Pirkimas uždarytas.',
	Tender_Details_MsgTenderPublished: 'Pirkimas paskelbtas.',
	Tender_Details_MsgTenderSuspended: 'Pirkimas sustabdytas.',
	Tender_Details_MsgTenderTimeExtended: 'Pirkimo laikas pratęstas.',
	Tender_Details_MsgParticipating: 'Dalyvavimas',
	Tender_Details_MsgReviewed: 'Peržiūrėjo',
	Tender_Details_MsgBidPlaced: 'Pasiūlymas pateiktas',
	Tender_Details_MsgStatusChanged: 'Statusas pakeistas',
	Tender_Details_MsgStatusNotChanged: 'Statusas ne pakeistas',
	Tender_Details_MsgTypeNotFound: 'Nerastas tipas',
	Tender_Details_MsgWaiting: 'Laukia',
	Tender_Details_MsgAccepted: 'Patvirtintas',
	Tender_Details_MsgRejected: 'Atmestas',
	Tender_Details_MsgUpdateFolderFaild: 'Nepavyko atnaujinti projekto',
	Tender_Details_MsgUpdateOwnerFaild: 'Nepavyko atnaujinti savininko',
	Tender_Details_Messages_MsgFailedToUploadDocument: '<strong>Klaida.</strong> Nepavyko įkelti failo.',

	Tender_SearchSuppliers_RemoveSupplier: 'Pašalinti',
	Tender_SearchSuppliers_AddSupplier: 'Pridėti',
	Tender_SearchSuppliers_AddedSupplier: 'Pridėtas',

	Tender_Bids_SendReminder: 'Išsiųsta',

	Tender_Suppliers_SendInvitation: 'Išsiųsta',

	Tender_Documents_MsgFailedToUploadDocument: '<strong>Klaida.</strong> Nepavyko įkelti failo.',

	Tender_List_ColStartsAt: 'Pradžia',
	Tender_List_ColEndsAt: 'Baigsis',
	Tender_List_ColEndedAt: 'Baigėsi',

	Bid_MsgBidArchived: 'Pasiūlymas suarchyvuotas.',
	Bid_MsgBidUnarchived: 'Pasiūlymas išarchyvuotas.',
	Bid_MsgRequestSent: 'Prašymas nusiųstas',
	Bid_MsgBidSent: 'Pasiūlymas nusiųstas',
	Bid_MsgBidCanceled: 'Pasiūlymas atšauktas',
	Bid_MsgPricesSaved: 'Kainos išsaugotos',
	Bid_MsgFailedToUploadDocument: '<strong>Klaida.</strong> Nepavyko įkelti failo.',
	Bid_MsgAnswersSaved: 'Atsakymai išsaugoti',
	Bid_MsgFailedToSaveAnswers: 'Nepavyko išsaugoti atsakymų.',
	Bid_MsgFailedToRemoveFromBookmarks: 'Nepavyko pašalinti iš žymių.',
	Bid_MsgFailedToAddToBookmarks: 'Nepavyko pridėti žymą',
	Bid_MsgFaildToSaveNote: 'Nepavyko įrašyti pastabą.',
	Bid_List_MsgFailedToSddToBookmarks: 'Nepavyko pridėti žymą.',
	Bid_List_MsgFailedToRemoveFromBookmarks: 'Nepavyko pašalinti iš žymių.',
	Bid_List_MsgFailedToAdd: 'Nepavyko pridėti.',
	Bid_List_MsgFailedToRemove: 'Nepavyko pašalinti.',
	Bid_List_ColActive: 'Pateikti iki',
	Bid_List_ColArchive: 'Baigėsi',
	Bid_List_ColPublic: 'Paskelbtas',
	Bid_List_ColBookmarked: 'Pateikti iki',
	Bid_Status_Draft: 'Nepateiktas',
	Bid_Status_Sent: 'Pateiktas',
	Bid_Status_WaitingForUpdate: 'Laukiama atnaujinimo',
	Bid_Status_Updated: 'Atnaujintas',

	Partner_MsgStatusNotChanged: 'Statusas nepakeistas.',
	Partner_Documents_MsgFailedToUploadDocument: '<strong>Klaida.</strong> Nepavyko įkelti failo.',
	Partners: {
	    Assign_Partner: 'Partneris',
	    Import_MsgFailedToUploadFile: '<strong>Klaida.</strong> nepavyko įkelti failo.',
	    Import_Importing: 'Prašome palaukti, importuojama',
	    Import_Done: 'Baigta'
	},

	Tag_MsgSuspended: 'Atidėtas',
	Tag_MsgDraft: 'Kuriamas',

	Pager_TotalRecords: '{0} - {1} iš {2}',

	PurchaseOrders: {
		PurchaseOrderStatus_Draft: 'Kuriamas',
		PurchaseOrderStatus_PriceQuotation: 'Kainų užklausa',
		PurchaseOrderStatus_PricesUpdated: 'Gautos kainos',
		PurchaseOrderStatus_Submitted: 'Pateiktas',
		PurchaseOrderStatus_Canceled: 'Atšauktas',
		PurchaseOrderStatus_SupplierCompleted: 'Tiekėjo įvykdytas',
		PurchaseOrderStatus_SupplierRejected: 'Tiekėjo atmestas',
		PurchaseOrderStatus_SupplierApproved: 'Tiekėjo patvirtintas',

		PurchaseRequestStatus_New: 'Nauja'
	},

    PurchaseOrder_Details_MsgPurchaseOrderArchived: 'Užsakymas suarchyvuotas.',
    PurchaseOrder_Details_MsgPurchaseOrderUnArchived: 'Užsakymas išarchyvuotas.',
    PurchaseOrder_Details_MsgPurchaseOrderItemsUpdateDone: 'Užsakymo produktai išsaugoti.',
    PurchaseOrder_List_ColPurchaseRequestName: 'Pavadinimas',
    PurchaseOrder_List_ColPurchaseOrderSupplierName: 'Tiekėjas',
    PurchaseOrder_List_OptPurchaseRequestOwnershipMy: 'Mano paraiškos',
    PurchaseOrder_List_OptPurchaseRequestOwnershipAll: 'Visos paraiškos',
    PurchaseOrder_List_OptPurchaseOrderOwnershipMy: 'Mano užsakymai',
    PurchaseOrder_List_OptPurchaseOrderOwnershipAll: 'Visi užsakymai',

    SupplierPurchaseOrders: {
        SupplierPurchaseOrderStatus_New: 'Naujas',
        SupplierPurchaseOrderStatus_Approved: 'Patvirtintas',
        SupplierPurchaseOrderStatus_Completed: 'Įvykdytas',
        SupplierPurchaseOrderStatus_Rejected: 'Atmestas',
        SupplierPurchaseOrderStatus_PriceQuotation: 'Kainų užklausa',
        SupplierPurchaseOrderStatus_PricesUpdated: 'Kainos nusiųstos'
    },

    BuyerProducts: {
    	Import_MsgFailedToUploadFile: '<strong>Klaida.</strong> nepavyko įkelti failo.',
    	Import_Importing: 'Prašome palaukti, importuojama',
    	Import_Done: 'Baigta'
    },

    BuyerCatalogs: {
        BuyerCatalogStatus_Waiting: 'Laukiantis',
        BuyerCatalogStatus_Approved: 'Aktyvus',
        BuyerCatalogStatus_Rejected: 'Atmestas',
        BuyerCatalogProductStatus_Added: 'Įsikeltas'
    },

    SupplierCatalogUsages: {
        SupplierCatalogUsageStatus_Waiting: 'Laukiantis',
        SupplierCatalogUsageStatus_Approved: 'Patvirtintas',
        SupplierCatalogUsageStatus_Rejected: 'Atmestas',
        Approve_Catalog_Message_Sent_Done: 'Katalogas patvirtintas',
        Reject_Catalog_Message_Sent_Done: 'Katalogas atmestas'
    },

    SupplierProducts: {
        Import_MsgFailedToUploadFile: '<strong>Klaida.</strong> nepavyko įkelti failo.',
        Import_Importing: 'Prašome palaukti, importuojama',
        Import_Done: 'Baigta',
        Activate_Catalog_Done: 'Katalogas aktyvuotas',
        Deactivate_Catalog_Done: 'Katalogas deaktyvuotas',
        Save_Catalog_Done: 'Katalogai išsaugoti',
        Save_Catalog_Fail: 'Įveskite korektišką nuolaidą (0-100%)'
    },

	PurchaseRequests: {
		PurchaseRequestStatus_Draft: 'Kuriama',
		PurchaseRequestStatus_WaitingForApproval: 'Laukia patvirtinimo',
		PurchaseRequestStatus_Submitted: 'Pateikta',
		PurchaseRequestStatus_Canceled: 'Anuliuota',
		PurchaseRequestStatus_Completed: 'Baigta',
        PurchaseRequestStatus_Processing: 'Vykdoma',
        PurchaseRequestStatus_Approved: 'Patvirtinta',

		Details_MsgPurchaseRequestArchived: 'Pirkimo paraiška suarchyvuota.',
		Details_MsgPurchaseRequestUnArchived: 'Pirkimo paraiška išarchyvuota.',

		ToOrders_MsgSuccess: 'Sukurti arba atnaujinti {0} užsakymai. Peržiūrėkite juos paraiškos užsakymų sąraše ir pateikite vykdymui.'
	}
};